/* eslint-disable no-unused-vars */
import React, {useState, useEffect, useCallback} from 'react'
import {useNavigate, useLocation} from 'react-router-dom'
import {useIntl} from 'react-intl'
import * as Yup from 'yup'
import {useFormik, FormikProvider, FieldArray} from 'formik'
import classNames from 'classnames'
import Dropdown from 'react-bootstrap/Dropdown'
import {KTSVG} from '../../../../helpers'

import {InvoiceType, ExpensePaymentStatus, TaxType, WitholdingType} from '../../../../helpers'
import {Select, SelectCreatable, InputPrice, Datepicker} from '../../../../components'

import {useDispatch, useSelector} from 'react-redux'

import {
  allCompanyLookup,
  projectLookup,
  allProductLookup,
  warehouseLookup,
  bankCashAccountGetAll,
  basicLookup,
  staffGetAll,
} from '../../../../redux/slices/lookup.slice'
import {expenseinvoiceDetailCreate} from '../../../../redux/slices/expenseinvoice.slice'
import {productGetInfo, productCreateFast} from '../../../../redux/slices/product.slice'
import {categoryGetAll} from '../../../../redux/slices/category.slice'
import {useMemoizedValidationSchema, useMemoizedFormValues} from '../../../../utils/performanceOptimizations'

const selectLookupData = (state) => ({
  productLookup: state.lookup.productLookup,
  projectLookupList: state.lookup.projectLookupList,
  companyLookup: state.lookup.companyLookup,
  warehouseLookupList: state.lookup.warehouseLookupList,
  accountLookupList: state.lookup.accountLookupList,
  ProductUnit: state.lookup.ProductUnit,
  DiscountType: state.lookup.DiscountType,
  staffLookup: state.lookup.staffLookup,
  InvoiceKind: state.lookup.InvoiceKind,
  category: state.category.category
})

const selectProductData = (state) => ({
  detail: state.product.detail,
  isRedirect: state.product.isRedirect
})

const ExpensesDetail = ({CompanyId}) => {
  const intl = useIntl()
  const navigate = useNavigate()
  const location = useLocation()
  const pageUrl = location.pathname.split('/')

  const {
    productLookup,
    projectLookupList,
    companyLookup,
    warehouseLookupList,
    accountLookupList,
    ProductUnit,
    DiscountType,
    staffLookup,
    InvoiceKind,
    category
  } = useSelector(selectLookupData)
  const {detail: product, isRedirect: createProduct} = useSelector(selectProductData)
  const dispatch = useDispatch()
  const [changeItem, setChangeItem] = useState()
  const [changeData, setChangeData] = useState()
  const [changeProduct, setChangeProduct] = useState()
  const [createItem, setCreateItem] = useState()
  const [visibiltyItem, setVisibiltyItem] = useState([
    {
      Discount: false,
      Description: false,
      WitholdingRate: false,
    },
  ])

  useEffect(() => {
    dispatch(allCompanyLookup())
    dispatch(projectLookup())
    dispatch(allProductLookup())
    dispatch(warehouseLookup())
    dispatch(bankCashAccountGetAll())
    dispatch(basicLookup('ProductUnit'))
    dispatch(basicLookup('DiscountType'))
    dispatch(staffGetAll())
    dispatch(categoryGetAll({SourceTypeId: 8}))
    dispatch(basicLookup('InvoiceKind'))
  }, [dispatch])

  const [stepSchema, setStepSchema] = useState({
    Name: Yup.string().required(intl.formatMessage({id: 'REQUIRED.GENERAL'})),
    ProjectId: Yup.string().required(intl.formatMessage({id: 'REQUIRED.GENERAL'})),
    InvoiceKindId: Yup.string().required(intl.formatMessage({id: 'REQUIRED.GENERAL'})),
    ExpenseInvoiceItems: Yup.array().of(
      Yup.object().shape({
        ProductId: Yup.string().required(intl.formatMessage({id: 'REQUIRED.GENERAL'})),
        Amount: Yup.number()
          .typeError(intl.formatMessage({id: 'REQUIRED.VALID'}))
          .required(intl.formatMessage({id: 'REQUIRED.GENERAL'})),
        UnitPrice: Yup.number()
          .typeError(intl.formatMessage({id: 'REQUIRED.VALID'}))
          .required(intl.formatMessage({id: 'REQUIRED.GENERAL'})),
        ProductUnitId: Yup.string().required(intl.formatMessage({id: 'REQUIRED.GENERAL'})),
        TaxId: Yup.string().required(intl.formatMessage({id: 'REQUIRED.GENERAL'})),
      })
    ),
  })

  const validSchema = useMemoizedValidationSchema(() =>
    Yup.object().shape(stepSchema), [stepSchema]
  )

  const formValues = useMemoizedFormValues({
    Name: '',
    InvoiceTypeId: 2,
    ProjectId: null,
    CompanyId: CompanyId || null,
    EditDate: new Date(),
    DefermentDate: new Date(),
    InvoiceNumber: '',
    SubTotalPrice: 0,
    TotalTax: 0,
    TotalDiscount: 0,
    GrossTotalPrice: 0,
    TotalWitholding: 0,
    TotalPrice: 0,
    ExpensePaymentStatusId: 1,
    FromAccountId: null,
    CheckoutName: null,
    PaymentDate: new Date(),
    ExpenseFile: null,
    RelatedStaffId: null,
    CategoryId: null,
    InvoiceKindId: '',
    ExpenseInvoiceItems: [
      {
        ProductId: null,
        WarehouseId: null,
        Amount: 1,
        UnitPrice: 0,
        ProductUnitId: 1,
        TaxId: 6,
        TotalTax: null,
        SubTotalPrice: 0,
        TotalPrice: 0,
        Description: null,
        DiscountTypeId: 1,
        DiscountRate: 0,
        Discount: null,
        WitholdingRateId: null,
        Witholding: null,
      },
    ],
  })

  const handleSubmit = useCallback(async (values, {setSubmitting, resetForm}) => {
    setSubmitting(true)
    dispatch(expenseinvoiceDetailCreate(values))
    resetForm()
  }, [dispatch])

  const formik = useFormik({
    initialValues: formValues,
    validationSchema: validSchema,
    onSubmit: handleSubmit,
  })

  useEffect(() => {
    if (formik.values.ExpensePaymentStatusId == 1) {
      setStepSchema({
        Name: Yup.string().required(intl.formatMessage({id: 'REQUIRED.GENERAL'})),
        ProjectId: Yup.string().required(intl.formatMessage({id: 'REQUIRED.GENERAL'})),
        InvoiceKindId: Yup.string().required(intl.formatMessage({id: 'REQUIRED.GENERAL'})),
        ExpenseInvoiceItems: Yup.array().of(
          Yup.object().shape({
            ProductId: Yup.string().required(intl.formatMessage({id: 'REQUIRED.GENERAL'})),
            Amount: Yup.number()
              .typeError(intl.formatMessage({id: 'REQUIRED.VALID'}))
              .required(intl.formatMessage({id: 'REQUIRED.GENERAL'})),
            UnitPrice: Yup.number()
              .typeError(intl.formatMessage({id: 'REQUIRED.VALID'}))
              .required(intl.formatMessage({id: 'REQUIRED.GENERAL'})),
            ProductUnitId: Yup.string().required(intl.formatMessage({id: 'REQUIRED.GENERAL'})),
            TaxId: Yup.string().required(intl.formatMessage({id: 'REQUIRED.GENERAL'})),
          })
        ),
      })
    } else {
      setStepSchema({
        Name: Yup.string().required(intl.formatMessage({id: 'REQUIRED.GENERAL'})),
        ProjectId: Yup.string().required(intl.formatMessage({id: 'REQUIRED.GENERAL'})),
        FromAccountId: Yup.string().required(intl.formatMessage({id: 'REQUIRED.GENERAL'})),
        CheckoutName: Yup.string().required(intl.formatMessage({id: 'REQUIRED.GENERAL'})),
        PaymentDate: Yup.string().required(intl.formatMessage({id: 'REQUIRED.GENERAL'})),
        InvoiceKindId: Yup.string().required(intl.formatMessage({id: 'REQUIRED.GENERAL'})),
        ExpenseInvoiceItems: Yup.array().of(
          Yup.object().shape({
            ProductId: Yup.string().required(intl.formatMessage({id: 'REQUIRED.GENERAL'})),
            Amount: Yup.number()
              .typeError(intl.formatMessage({id: 'REQUIRED.VALID'}))
              .required(intl.formatMessage({id: 'REQUIRED.GENERAL'})),
            UnitPrice: Yup.number()
              .typeError(intl.formatMessage({id: 'REQUIRED.VALID'}))
              .required(intl.formatMessage({id: 'REQUIRED.GENERAL'})),
            ProductUnitId: Yup.string().required(intl.formatMessage({id: 'REQUIRED.GENERAL'})),
            TaxId: Yup.string().required(intl.formatMessage({id: 'REQUIRED.GENERAL'})),
          })
        ),
      })
    }
  }, [formik.values.ExpensePaymentStatusId, intl])

  const onChangeItem = useCallback((target, value, index) => {
    setChangeItem({index, target})
    formik.setFieldValue(`ExpenseInvoiceItems[${index}][${target}]`, value)
  }, [])

  const sumArrayItem = useCallback((item) =>
    formik.values.ExpenseInvoiceItems.reduce((a, v) => (a = a + v[item]), 0), [formik.values.ExpenseInvoiceItems])

  useEffect(() => {
    const expenseInvoiceItems = formik.values.ExpenseInvoiceItems[changeItem && changeItem.index]

    if (expenseInvoiceItems) {
      const subTotalPrice = Number((expenseInvoiceItems.UnitPrice * expenseInvoiceItems.Amount).toFixed(4))
      const discount = Number((
        expenseInvoiceItems.DiscountTypeId == 1
          ? (subTotalPrice * expenseInvoiceItems.DiscountRate) / 100
          : expenseInvoiceItems.DiscountRate
      ).toFixed(4))
      const tax = TaxType.find((item) => item.id == expenseInvoiceItems.TaxId)
      const totalTax = Number((((subTotalPrice - discount) * (tax && tax.value || 0)) / 100).toFixed(4))
      const witholdingRate = WitholdingType.find(
        (item) => item.id == expenseInvoiceItems.WitholdingRateId
      )
      const witholding = Number(((totalTax * (witholdingRate && witholdingRate.value || 0)) / 100).toFixed(4))
      const totalPrice = Number((subTotalPrice + totalTax - (witholding + discount)).toFixed(4))

      formik.setFieldValue(`ExpenseInvoiceItems[${changeItem && changeItem.index}].SubTotalPrice`, subTotalPrice)
      formik.setFieldValue(`ExpenseInvoiceItems[${changeItem && changeItem.index}].Discount`, discount)
      formik.setFieldValue(`ExpenseInvoiceItems[${changeItem && changeItem.index}].TotalTax`, totalTax)
      formik.setFieldValue(`ExpenseInvoiceItems[${changeItem && changeItem.index}].Witholding`, witholding)
      formik.setFieldValue(`ExpenseInvoiceItems[${changeItem && changeItem.index}].TotalPrice`, totalPrice)

      setChangeData(totalPrice)
    }
  }, [changeItem, formik.values.ExpenseInvoiceItems])

  useEffect(() => {
    formik.setFieldValue('SubTotalPrice', sumArrayItem('SubTotalPrice'))
    formik.setFieldValue('TotalTax', sumArrayItem('TotalTax'))
    formik.setFieldValue('TotalDiscount', sumArrayItem('Discount'))
    formik.setFieldValue(
      'GrossTotalPrice',
      sumArrayItem('SubTotalPrice') - sumArrayItem('Discount')
    )
    formik.setFieldValue('TotalWitholding', sumArrayItem('Witholding'))
    formik.setFieldValue('TotalPrice', sumArrayItem('TotalPrice'))
  }, [changeData, sumArrayItem])

  const onClickNewItem = useCallback((arrayHelpers) => {
    arrayHelpers.push({
      ProductId: null,
      WarehouseId: null,
      Amount: 1,
      UnitPrice: 0,
      ProductUnitId: 1,
      TaxId: 6,
      TotalTax: null,
      SubTotalPrice: 0,
      TotalPrice: 0,
      Description: null,
      DiscountTypeId: 1,
      DiscountRate: 0,
      Discount: null,
      WitholdingRateId: null,
      Witholding: null,
    })
    setVisibiltyItem([
      ...visibiltyItem,
      {
        Discount: false,
        Description: false,
        WitholdingRate: false,
      },
    ])
  }, [visibiltyItem])

  const onClickVisibityItem = useCallback((item, index) => {
    const newArr = [...visibiltyItem]
    newArr[index][item] = !newArr[index][item]
    setVisibiltyItem(newArr)
  }, [visibiltyItem])

  const onChangeProduct = useCallback((item, index) => {
    formik.setFieldValue(`ExpenseInvoiceItems[${index}].ProductId`, Number(item && item.value))
    setChangeProduct(index)
    dispatch(productGetInfo({Id: item && item.value}))
  }, [dispatch])

  useEffect(() => {
    if (product) {
      formik.setFieldValue(
        `ExpenseInvoiceItems[${changeProduct}].ProductUnitId`,
        product && product.productUnitId
      )
      formik.setFieldValue(
        `ExpenseInvoiceItems[${changeProduct}].UnitPrice`,
        product && product.baseSalePrice
      )
      formik.setFieldValue(`ExpenseInvoiceItems[${changeProduct}].TaxId`, product && product.taxId)
      setChangeItem({index: changeProduct, target: 'UnitPrice'})
    }
  }, [product, changeProduct])

  const onClickFastProduct = useCallback((Name, Index) => {
    dispatch(productCreateFast({Name}))
    setCreateItem({Name, Index})
  }, [dispatch])

  useEffect(() => {
    if (createProduct) dispatch(allProductLookup())
  }, [createProduct, dispatch])

  useEffect(() => {
    if (productLookup && createProduct) {
      formik.setFieldValue(`ExpenseInvoiceItems[${createItem && createItem.Index}].ProductId`, createProduct.id)
    }
  }, [productLookup, createProduct, createItem])

  return (
    <FormikProvider value={formik}>
      <form className='form' onSubmit={formik.handleSubmit} noValidate>
        <div className='row mb-6'>
          <label className='col-lg-3 required fw-bold fs-6 mb-2'>
            {intl.formatMessage({id: 'EXPENSEINVOICE.CREATEDETAIL.NAME'})}
          </label>
          <div className='col-lg-6 fv-row fv-plugins-icon-container'>
            <input
              type='text'
              className='form-control form-control-solid mb-3 mb-lg-0'
              autoComplete='off'
              required
              disabled={formik.isSubmitting}
              {...formik.getFieldProps('Name')}
            />
            {formik.touched.Name && formik.errors.Name && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span role='alert'>{formik.errors.Name}</span>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className='row mb-6'>
          <label className='col-lg-3 fw-bold fs-6 mb-2'>
            {intl.formatMessage({id: 'EXPENSEINVOICE.CREATEDETAIL.CATEGORY'})}
          </label>
          <div className='col-lg-6 fv-row fv-plugins-icon-container'>
            <Select
              data={category}
              {...formik.getFieldProps('CategoryId')}
              onChange={(item) => formik.setFieldValue('CategoryId', Number(item && item.value))}
              menuPortalTarget={CompanyId ? null : document.body}
            />
          </div>
        </div>

        <div className='row mb-6'>
          <label className='col-lg-3 fw-bold fs-6 mb-2'>
            {intl.formatMessage({id: 'EXPENSEINVOICE.CREATEDETAIL.COMPANYID'})}
          </label>
          <div className='col-lg-6 fv-row fv-plugins-icon-container'>
            <Select
              data={companyLookup}
              {...formik.getFieldProps('CompanyId')}
              onChange={(item) => formik.setFieldValue('CompanyId', Number(item && item.value))}
              disabled={CompanyId}
              menuPortalTarget={CompanyId ? null : document.body}
            />
          </div>
        </div>

        <div className='row mb-6'>
          <label className='col-lg-3 fw-bold fs-6 mb-2 required'>
            {intl.formatMessage({id: 'EXPENSEINVOICE.CREATEDETAIL.PROJECTID'})}
          </label>
          <div className='col-lg-6 fv-row fv-plugins-icon-container'>
            <Select
              data={projectLookupList}
              required
              {...formik.getFieldProps('ProjectId')}
              onChange={(item) => formik.setFieldValue('ProjectId', Number(item && item.value))}
              menuPortalTarget={CompanyId ? null : document.body}
            />
            {formik.touched.ProjectId && formik.errors.ProjectId && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span role='alert'>{formik.errors.ProjectId}</span>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className='row mb-6'>
          <label className='col-lg-3 fw-bold fs-6 mb-2 required'>
            {intl.formatMessage({id: 'SALEINVOICE.CREATE.INVOICEKINDNAME'})}
          </label>
          <div className='col-lg-6 fv-row fv-plugins-icon-container'>
            <Select
              data={InvoiceKind}
              required
              {...formik.getFieldProps('InvoiceKindId')}
              onChange={(item) => formik.setFieldValue('InvoiceKindId', Number(item && item.value))}
              menuPortalTarget={CompanyId ? null : document.body}
            />
            {formik.touched.InvoiceKind && formik.errors.InvoiceKind && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span role='alert'>{formik.errors.InvoiceKind}</span>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className='row mb-6'>
          <label className='col-lg-3 fw-bold fs-6 mb-2'>
            {intl.formatMessage({id: 'EXPENSEINVOICE.CREATEDETAIL.INVOICETYPEID'})}
          </label>
          <div className='col-lg-6 fv-row fv-plugins-icon-container d-flex gap-10'>
            {InvoiceType.map((item, index) => {
              return (
                <div
                  className='form-check form-check-custom form-check-solid form-check-sm'
                  key={index}
                >
                  <input
                    className='form-check-input'
                    name='InvoiceTypeId'
                    type='radio'
                    value={item.Id}
                    id={`InvoiceTypeId-${index}`}
                    onChange={() => formik.setFieldValue('InvoiceTypeId', item.Id)}
                    defaultChecked={item.Id === 2}
                  />
                  <label className='form-check-label' htmlFor={`InvoiceTypeId-${index}`}>
                    {intl.formatMessage({id: item.Name})}
                  </label>
                </div>
              )
            })}
          </div>
        </div>

        <div className='row mb-6'>
          <label className='col-lg-3 fw-bold fs-6 mb-2'>
            {intl.formatMessage({id: 'EXPENSEINVOICE.CREATEDETAIL.EXPENSEPAYMENTSTATUSID'})}
          </label>
          <div className='col-lg-6 fv-row fv-plugins-icon-container d-flex gap-10'>
            {ExpensePaymentStatus.map((item, index) => {
              return (
                <div
                  className='form-check form-check-custom form-check-solid form-check-sm'
                  key={index}
                >
                  <input
                    className='form-check-input'
                    name='ExpensePaymentStatusId'
                    type='radio'
                    value={item.Id}
                    id={`ExpensePaymentStatusId-${index}`}
                    defaultChecked={item.Id === 1}
                    onChange={() => formik.setFieldValue('ExpensePaymentStatusId', item.Id)}
                  />
                  <label className='form-check-label' htmlFor={`ExpensePaymentStatusId-${index}`}>
                    {intl.formatMessage({id: item.Name})}
                  </label>
                </div>
              )
            })}
          </div>
        </div>

        {formik.values.ExpensePaymentStatusId == 1 && (
          <>
            <div className='row mb-6'>
              <label className='col-lg-3 fw-bold fs-6 mb-2'>
                {intl.formatMessage({id: 'EXPENSEINVOICE.CREATEDETAIL.EDITDATE'})}
              </label>
              <div className='col-lg-6 fv-row fv-plugins-icon-container'>
                <Datepicker
                  {...formik.getFieldProps('EditDate')}
                  onChange={([date]) => formik.setFieldValue('EditDate', date)}
                />
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-3 fw-bold fs-6 mb-2'>
                {intl.formatMessage({id: 'EXPENSEINVOICE.CREATEDETAIL.DEFERMENTDATE'})}
              </label>
              <div className='col-lg-6 fv-row fv-plugins-icon-container'>
                <Datepicker
                  {...formik.getFieldProps('DefermentDate')}
                  onChange={([date]) => formik.setFieldValue('DefermentDate', date)}
                />
              </div>
            </div>
          </>
        )}

        {formik.values.ExpensePaymentStatusId == 2 && (
          <>
            <div className='row mb-6'>
              <label className='col-lg-3 fw-bold fs-6 mb-2 required'>
                {intl.formatMessage({id: 'EXPENSEINVOICE.CREATEDETAIL.PAYMENTDATE'})}
              </label>
              <div className='col-lg-6 fv-row fv-plugins-icon-container'>
                <Datepicker
                  required
                  {...formik.getFieldProps('PaymentDate')}
                  onChange={([date]) => formik.setFieldValue('PaymentDate', date)}
                />

                {formik.touched.PaymentDate && formik.errors.PaymentDate && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert'>{formik.errors.PaymentDate}</span>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-3 fw-bold fs-6 mb-2 required'>
                {intl.formatMessage({id: 'EXPENSEINVOICE.CREATEDETAIL.FROMACCOUNTID'})}
              </label>
              <div className='col-lg-6 fv-row fv-plugins-icon-container'>
                <Select
                  data={accountLookupList}
                  required
                  {...formik.getFieldProps('FromAccountId')}
                  onChange={(item) => formik.setFieldValue('FromAccountId', Number(item && item.value))}
                  menuPortalTarget={CompanyId ? null : document.body}
                />
                {formik.touched.FromAccountId && formik.errors.FromAccountId && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert'>{formik.errors.FromAccountId}</span>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-3 fw-bold fs-6 mb-2 required'>
                {intl.formatMessage({id: 'EXPENSEINVOICE.CREATEDETAIL.CHECKOUTNAME'})}
              </label>
              <div className='col-lg-6 fv-row fv-plugins-icon-container'>
                <textarea
                  className='form-control form-control-solid mb-3 mb-lg-0'
                  autoComplete='off'
                  disabled={formik.isSubmitting}
                  required
                  rows={4}
                  {...formik.getFieldProps('CheckoutName')}
                />
                {formik.touched.CheckoutName && formik.errors.CheckoutName && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert'>{formik.errors.CheckoutName}</span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </>
        )}

        <div className='row mb-6'>
          <label className='col-lg-3 fw-bold fs-6 mb-2'>
            {intl.formatMessage({id: 'EXPENSEINVOICE.CREATEDETAIL.RELATEDSTAFFID'})}
          </label>
          <div className='col-lg-6 fv-row fv-plugins-icon-container'>
            <Select
              data={staffLookup}
              required
              {...formik.getFieldProps('RelatedStaffId')}
              onChange={(item) => formik.setFieldValue('RelatedStaffId', Number(item && item.value))}
              menuPortalTarget={CompanyId ? null : document.body}
            />
          </div>
        </div>

        <div className='row mb-6'>
          <label className='col-lg-3 fw-bold fs-6 mb-2'>
            {intl.formatMessage({id: 'EXPENSEINVOICE.CREATEDETAIL.INVOICENUMBER'})}
          </label>
          <div className='col-lg-6 fv-row fv-plugins-icon-container'>
            <input
              type='text'
              className='form-control form-control-solid mb-3 mb-lg-0'
              autoComplete='off'
              disabled={formik.isSubmitting}
              {...formik.getFieldProps('InvoiceNumber')}
            />
          </div>
        </div>

        <div className='row mb-6'>
          <label className='col-lg-3 fw-bold fs-6 mb-2'>
            {intl.formatMessage({id: 'EXPENSEINVOICE.CREATEDETAIL.FILEID'})}
          </label>
          <div className='col-lg-6 fv-row fv-plugins-icon-container'>
            <label
              htmlFor='ExpenseFile'
              className='btn btn-outline btn-outline-dashed btn-outline-dark btn-active-light-dark position-relative overflow-hidden'
            >
              <input
                className='position-absolute z-index-2 opacity-0 w-1px h-1px'
                type='file'
                accept='image/*,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.kmz,.kml,.ncz,.dwg'
                id={'ExpenseFile'}
                name={'ExpenseFile'}
                onChange={(event) =>
                  formik.setFieldValue('ExpenseFile', event.currentTarget.files[0])
                }
              />
              <KTSVG
                path='/images/icons/duotune/communication/com008.svg'
                className='svg-icon-3 position-relative'
              />
              {intl.formatMessage({id: 'EXPENSEINVOICE.CREATEDETAIL.FILEID'})}
            </label>
          </div>
        </div>

        <FieldArray
          name='ExpenseInvoiceItems'
          render={(arrayHelpers) => (
            <>
              <div className='table-responsive'>
                <table className='table g-5 gs-0 mb-0 fw-bold text-gray-700'>
                  <thead>
                    <tr className='border-bottom fs-7 fw-bold text-gray-700 text-uppercase'>
                      <th>
                        {intl.formatMessage({
                          id: 'EXPENSEINVOICE.CREATEDETAIL.EXPENSEINVOICEITEMS.PRODUCTID',
                        })}
                      </th>
                      {formik.values.InvoiceTypeId === 1 && (
                        <th>
                          {intl.formatMessage({
                            id: 'EXPENSEINVOICE.CREATEDETAIL.EXPENSEINVOICEITEMS.WAREHOUSEID',
                          })}
                        </th>
                      )}
                      <th>
                        {intl.formatMessage({
                          id: 'EXPENSEINVOICE.CREATEDETAIL.EXPENSEINVOICEITEMS.AMOUNT',
                        })}
                      </th>
                      <th>
                        {intl.formatMessage({
                          id: 'EXPENSEINVOICE.CREATEDETAIL.EXPENSEINVOICEITEMS.PRODUCTUNITID',
                        })}
                      </th>
                      <th>
                        {intl.formatMessage({
                          id: 'EXPENSEINVOICE.CREATEDETAIL.EXPENSEINVOICEITEMS.UNITPRICE',
                        })}
                      </th>
                      <th>
                        {intl.formatMessage({
                          id: 'EXPENSEINVOICE.CREATEDETAIL.EXPENSEINVOICEITEMS.TAXID',
                        })}
                      </th>
                      <th>
                        {intl.formatMessage({
                          id: 'EXPENSEINVOICE.CREATEDETAIL.EXPENSEINVOICEITEMS.TOTALPRICE',
                        })}
                      </th>
                      <th>&nbsp;</th>
                    </tr>
                  </thead>
                  <tbody>
                    {formik.values.ExpenseInvoiceItems.map((item, index) => (
                      <tr className='border-bottom border-bottom-dashed' key={index}>
                        <td className='pe-7 ps-1'>
                          <SelectCreatable
                            data={productLookup}
                            name={`ExpenseInvoiceItems[${index}].ProductId`}
                            value={formik.values.ExpenseInvoiceItems[index].ProductId}
                            required
                            onChange={(item) => onChangeProduct(item, index)}
                            onCreate={(item) => onClickFastProduct(item, index)}
                            menuPortalTarget={CompanyId ? null : document.body}
                          />

                          {visibiltyItem[index].Description && (
                            <input
                              type='text'
                              className='form-control form-control-solid mt-2'
                              autoComplete='off'
                              disabled={formik.isSubmitting}
                              placeholder={intl.formatMessage({
                                id: 'EXPENSEINVOICE.CREATEDETAIL.EXPENSEINVOICEITEMS.DESCRIPTION',
                              })}
                              name={`ExpenseInvoiceItems[${index}].Description`}
                              value={formik.values.ExpenseInvoiceItems[index].Description}
                              onChange={formik.handleChange}
                            />
                          )}
                        </td>

                        {formik.values.InvoiceTypeId === 1 && (
                          <td className='ps-0'>
                            <Select
                              data={warehouseLookupList}
                              name={`ExpenseInvoiceItems[${index}].WarehouseId`}
                              value={formik.values.ExpenseInvoiceItems[index].WarehouseId}
                              required
                              onChange={(item) =>
                                formik.setFieldValue(
                                  `ExpenseInvoiceItems[${index}].WarehouseId`,
                                  Number(item && item.value)
                                )
                              }
                              menuPortalTarget={CompanyId ? null : document.body}
                            />
                          </td>
                        )}

                        <td className='ps-0'>
                          <input
                            type='number'
                            className='form-control form-control-solid'
                            autoComplete='off'
                            disabled={formik.isSubmitting}
                            placeholder={intl.formatMessage({
                              id: 'EXPENSEINVOICE.CREATEDETAIL.EXPENSEINVOICEITEMS.AMOUNT',
                            })}
                            name={`ExpenseInvoiceItems[${index}].Amount`}
                            value={formik.values.ExpenseInvoiceItems[index].Amount}
                            required
                            onChange={(event) =>
                              onChangeItem('Amount', Number(event.target.value), index)
                            }
                            onFocus={(event) => event.target.select()}
                          />

                          {visibiltyItem[index].Discount && (
                            <div className='input-group mt-2'>
                              <input
                                type='number'
                                className='form-control form-control-solid'
                                autoComplete='off'
                                disabled={formik.isSubmitting}
                                placeholder={intl.formatMessage({
                                  id: 'EXPENSEINVOICE.CREATEDETAIL.EXPENSEINVOICEITEMS.DISCOUNTRATE',
                                })}
                                name={`ExpenseInvoiceItems[${index}].DiscountRate`}
                                value={formik.values.ExpenseInvoiceItems[index].DiscountRate}
                                onChange={(event) =>
                                  onChangeItem('DiscountRate', Number(event.target.value), index)
                                }
                                onFocus={(event) => event.target.select()}
                              />
                              <Select
                                data={DiscountType}
                                name={`ExpenseInvoiceItems[${index}].DiscountTypeId`}
                                value={formik.values.ExpenseInvoiceItems[index].DiscountTypeId}
                                required
                                onChange={(item) =>
                                  onChangeItem('DiscountTypeId', Number(item && item.value), index)
                                }
                                menuPortalTarget={CompanyId ? null : document.body}
                              />
                            </div>
                          )}
                        </td>

                        <td className='ps-0'>
                          <Select
                            data={ProductUnit}
                            name={`ExpenseInvoiceItems[${index}].ProductUnitId`}
                            value={formik.values.ExpenseInvoiceItems[index].ProductUnitId}
                            required
                                                          onChange={(item) =>
                                onChangeItem('ProductUnitId', Number(item && item.value), index)
                              }
                            menuPortalTarget={CompanyId ? null : document.body}
                          />

                          {visibiltyItem[index].WitholdingRate && (
                            <Select
                              data={WitholdingType}
                              className={'mt-2'}
                              name={`ExpenseInvoiceItems[${index}].WitholdingRateId`}
                              value={formik.values.ExpenseInvoiceItems[index].WitholdingRateId}
                              required
                              onChange={(item) =>
                                onChangeItem('WitholdingRateId', Number(item && item.value), index)
                              }
                              menuPortalTarget={CompanyId ? null : document.body}
                            />
                          )}
                        </td>

                        <td className='ps-0'>
                          <InputPrice
                            placeholder={intl.formatMessage({
                              id: 'EXPENSEINVOICE.CREATEDETAIL.EXPENSEINVOICEITEMS.UNITPRICE',
                            })}
                            name={`ExpenseInvoiceItems[${index}].UnitPrice`}
                            required
                            value={formik.values.ExpenseInvoiceItems[index].UnitPrice}
                            onChange={(value) => onChangeItem('UnitPrice', Number(value), index)}
                          />
                        </td>

                        <td className='ps-0'>
                          <Select
                            data={TaxType}
                            name={`ExpenseInvoiceItems[${index}].TaxId`}
                            value={formik.values.ExpenseInvoiceItems[index].TaxId}
                            required
                            onChange={(item) => onChangeItem('TaxId', Number(item && item.value), index)}
                            menuPortalTarget={CompanyId ? null : document.body}
                          />
                        </td>

                        <td className='ps-0'>
                          <InputPrice
                            placeholder={intl.formatMessage({
                              id: 'EXPENSEINVOICE.CREATEDETAIL.EXPENSEINVOICEITEMS.TOTALPRICE',
                            })}
                            name={`ExpenseInvoiceItems[${index}].TotalPrice`}
                            value={formik.values.ExpenseInvoiceItems[index].TotalPrice}
                            onChange={(value) => onChangeItem('TotalPrice', Number(value), index)}
                          />
                        </td>

                        <td className='pt-5 text-end'>
                          <div className='d-flex'>
                            <Dropdown autoClose='outside'>
                              <Dropdown.Toggle
                                variant='link'
                                className='btn btn-sm btn-icon btn-active-color-info'
                              >
                                <KTSVG
                                  path='/images/icons/duotune/arrows/arr009.svg'
                                  className='svg-icon-2'
                                />
                              </Dropdown.Toggle>

                              <Dropdown.Menu>
                                <Dropdown.Item
                                  onClick={() => onClickVisibityItem('Discount', index)}
                                  className={classNames({active: visibiltyItem[index].Discount})}
                                >
                                  {intl.formatMessage({
                                    id: 'EXPENSEINVOICE.CREATEDETAIL.EXPENSEINVOICEITEMS.DISCOUNT',
                                  })}
                                </Dropdown.Item>
                                <Dropdown.Item
                                  onClick={() => onClickVisibityItem('Description', index)}
                                  className={classNames({active: visibiltyItem[index].Description})}
                                >
                                  {intl.formatMessage({
                                    id: 'EXPENSEINVOICE.CREATEDETAIL.EXPENSEINVOICEITEMS.DESCRIPTION',
                                  })}
                                </Dropdown.Item>
                                <Dropdown.Item
                                  onClick={() => onClickVisibityItem('WitholdingRate', index)}
                                  className={classNames({
                                    active: visibiltyItem[index].WitholdingRate,
                                  })}
                                >
                                  {intl.formatMessage({
                                    id: 'EXPENSEINVOICE.CREATEDETAIL.EXPENSEINVOICEITEMS.WITHOLDINGRATEID',
                                  })}
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                            <button
                              type='button'
                              className='btn btn-sm btn-icon btn-active-color-primary'
                              onClick={() => arrayHelpers.remove(index)}
                            >
                              <KTSVG
                                path='/images/icons/duotune/general/gen027.svg'
                                className='svg-icon-2'
                              />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr className='border-top border-top-dashed align-middle fs-6 fw-bold text-gray-700'>
                      <th colSpan={formik.values.InvoiceTypeId === 1 ? 4 : 3}>
                        <button
                          type='button'
                          className='btn btn-sm btn-outline btn-outline-dashed btn-outline-success btn-active-light-success'
                          onClick={() => onClickNewItem(arrayHelpers)}
                        >
                          <KTSVG
                            path='/images/icons/duotune/arrows/arr009.svg'
                            className='svg-icon-2'
                          />
                          {intl.formatMessage({id: 'ADD_NEW_LINE'})}
                        </button>
                      </th>
                      <th className='border-bottom border-bottom-dashed ps-0 fs-5' colSpan={2}>
                        {intl.formatMessage({id: 'EXPENSEINVOICE.CREATEDETAIL.SUBTOTALPRICE'})}
                      </th>
                      <th className='border-bottom border-bottom-dashed text-end'>
                        {intl.formatNumber(formik.values.SubTotalPrice, {
                          style: 'currency',
                          currency: 'try',
                        })}
                      </th>
                      <th>&nbsp;</th>
                    </tr>

                    {formik.values.TotalDiscount > 0 && (
                      <tr className='align-middle fw-bold text-gray-700'>
                        <th colSpan={formik.values.InvoiceTypeId === 1 ? 4 : 3}></th>
                        <th className='border-bottom border-bottom-dashed ps-0 fs-5' colSpan={2}>
                          {intl.formatMessage({id: 'EXPENSEINVOICE.CREATEDETAIL.TOTALDISCOUNT'})}
                        </th>
                        <th className='border-bottom border-bottom-dashed text-end'>
                          {intl.formatNumber(formik.values.TotalDiscount, {
                            style: 'currency',
                            currency: 'try',
                          })}
                        </th>
                        <th>&nbsp;</th>
                      </tr>
                    )}

                    <tr className='align-middle fw-bold text-gray-700'>
                      <th colSpan={formik.values.InvoiceTypeId === 1 ? 4 : 3}></th>
                      <th className='border-bottom border-bottom-dashed ps-0 fs-5' colSpan={2}>
                        {intl.formatMessage({id: 'EXPENSEINVOICE.CREATEDETAIL.GROSSTOTALPRICE'})}
                      </th>
                      <th className='border-bottom border-bottom-dashed text-end'>
                        {intl.formatNumber(formik.values.GrossTotalPrice, {
                          style: 'currency',
                          currency: 'try',
                        })}
                      </th>
                      <th>&nbsp;</th>
                    </tr>

                    <tr className='align-middle fw-bold text-gray-700'>
                      <th colSpan={formik.values.InvoiceTypeId === 1 ? 4 : 3}></th>
                      <th className='border-bottom border-bottom-dashed ps-0 fs-5' colSpan={2}>
                        {intl.formatMessage({id: 'EXPENSEINVOICE.CREATEDETAIL.TOTALTAX'})}
                      </th>
                      <th className='border-bottom border-bottom-dashed text-end'>
                        {intl.formatNumber(formik.values.TotalTax, {
                          style: 'currency',
                          currency: 'try',
                        })}
                      </th>
                      <th>&nbsp;</th>
                    </tr>

                    {formik.values.TotalWitholding > 0 && (
                      <tr className='align-middle fw-bold text-gray-700'>
                        <th colSpan={formik.values.InvoiceTypeId === 1 ? 4 : 3}></th>
                        <th className='border-bottom border-bottom-dashed ps-0 fs-5' colSpan={2}>
                          {intl.formatMessage({id: 'EXPENSEINVOICE.CREATEDETAIL.TOTALWITHOLDING'})}
                        </th>
                        <th className='border-bottom border-bottom-dashed text-end'>
                          {intl.formatNumber(formik.values.TotalWitholding, {
                            style: 'currency',
                            currency: 'try',
                          })}
                        </th>
                        <th>&nbsp;</th>
                      </tr>
                    )}

                    <tr className='align-middle fw-bold text-gray-700'>
                      <th colSpan={formik.values.InvoiceTypeId === 1 ? 4 : 3}></th>
                      <th className='fs-4 ps-0' colSpan={2}>
                        {intl.formatMessage({id: 'EXPENSEINVOICE.CREATEDETAIL.TOTALPRICE'})}
                      </th>
                      <th className='text-end fs-4 text-nowrap'>
                        {intl.formatNumber(formik.values.TotalPrice, {
                          style: 'currency',
                          currency: 'try',
                        })}
                      </th>
                      <th>&nbsp;</th>
                    </tr>

                    {formik.values.TotalWitholding > 0 && (
                      <tr className='align-middle fw-bold text-gray-700'>
                        <th colSpan={formik.values.InvoiceTypeId === 1 ? 4 : 3}></th>
                        <th className='fs-4 ps-0' colSpan={2}>
                          {intl.formatMessage({
                            id: 'EXPENSEINVOICE.CREATEDETAIL.TOTALPRICEPLUSWITHHOLDING',
                          })}
                        </th>
                        <th className='text-end fs-4 text-nowrap'>
                          {intl.formatNumber(
                            formik.values.TotalPrice + formik.values.TotalWitholding,
                            {style: 'currency', currency: 'try', minimumFractionDigits: 2, maximumFractionDigits: 4}
                          )}
                        </th>
                        <th>&nbsp;</th>
                      </tr>
                    )}
                  </tfoot>
                </table>
              </div>
            </>
          )}
        />

        <div className='row pt-15'>
          <div className='col-lg-9 fv-row fv-plugins-icon-container d-flex gap-3 justify-content-center'>
            {!CompanyId && (
              <button
                className='btn btn-light'
                onClick={() => navigate(`/${pageUrl[1]}/${pageUrl[2]}`)}
              >
                {intl.formatMessage({id: 'BUTTON.CANCEL'})}
              </button>
            )}
            <button
              type='submit'
              className='btn btn-primary'
              data-kt-users-modal-action='submit'
              disabled={formik.isSubmitting || !formik.isValid || !formik.touched}
            >
              <span className='indicator-label'>{intl.formatMessage({id: 'BUTTON.SUBMIT'})}</span>
              {formik.isSubmitting && (
                <span className='indicator-progress'>
                  {intl.formatMessage({id: 'PLEASE'})}
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
          </div>
        </div>
      </form>
    </FormikProvider>
  )
}

export {ExpensesDetail}
